import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ExchangeRateWidget = () => {
  const [lastUpdated, setLastUpdated] = useState(new Date());

  const exchangeRates = [
    {
      id: 'usd-eur',
      from: 'USD',
      to: 'EUR',
      rate: '0.9235',
      change: '+0.0012',
      changePercent: '+0.13%',
      trend: 'up',
      flag: '🇪🇺'
    },
    {
      id: 'usd-gbp',
      from: 'USD',
      to: 'GBP',
      rate: '0.7891',
      change: '-0.0023',
      changePercent: '-0.29%',
      trend: 'down',
      flag: '🇬🇧'
    },
    {
      id: 'usd-cad',
      from: 'USD',
      to: 'CAD',
      rate: '1.3945',
      change: '+0.0056',
      changePercent: '+0.40%',
      trend: 'up',
      flag: '🇨🇦'
    },
    {
      id: 'usd-aud',
      from: 'USD',
      to: 'AUD',
      rate: '1.5234',
      change: '+0.0089',
      changePercent: '+0.59%',
      trend: 'up',
      flag: '🇦🇺'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setLastUpdated(new Date());
    }, 30000); // Update every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const formatTime = (date) => {
    return date?.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">Live Exchange Rates</h2>
        <div className="flex items-center space-x-2 text-xs text-muted-foreground">
          <Icon name="RefreshCw" size={12} />
          <span>Updated: {formatTime(lastUpdated)}</span>
        </div>
      </div>
      <div className="space-y-4">
        {exchangeRates?.map((rate) => (
          <div key={rate?.id} className="flex items-center justify-between p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors">
            <div className="flex items-center space-x-3">
              <span className="text-lg">{rate?.flag}</span>
              <div>
                <p className="text-sm font-medium text-foreground">
                  {rate?.from}/{rate?.to}
                </p>
                <p className="text-xs text-muted-foreground">
                  1 {rate?.from} = {rate?.rate} {rate?.to}
                </p>
              </div>
            </div>
            
            <div className="text-right">
              <p className="text-sm font-semibold text-foreground">{rate?.rate}</p>
              <div className="flex items-center space-x-1">
                <Icon 
                  name={rate?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                  size={12} 
                  color={rate?.trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'}
                />
                <span className={`text-xs font-medium ${
                  rate?.trend === 'up' ? 'text-success' : 'text-error'
                }`}>
                  {rate?.changePercent}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 bg-accent/10 rounded-lg">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} color="var(--color-accent)" className="mt-0.5" />
          <div>
            <p className="text-xs font-medium text-accent">Rate Information</p>
            <p className="text-xs text-muted-foreground mt-1">
              Rates include our competitive margin. Final rates may vary based on transfer amount and payment method.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExchangeRateWidget;